"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
var createRoute = function (name) {
    return {
        name: name,
        createFunction: function (fn) { return fn; },
        createFetcher: function (firebaseObj) {
            var fn = firebaseObj.httpsCallable(name);
            return fn;
        }
    };
};
exports.routes = {
    stockHistory: createRoute('requestStockHistory'),
    stockSearch: createRoute('requestStockSearch'),
    goldHistory: createRoute('requestGoldHistory'),
};
